(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerCategorySearch', CustomerCategorySearch);

    CustomerCategorySearch.$inject = ['$resource'];

    function CustomerCategorySearch($resource) {
        var resourceUrl =  'api/_search/customer-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
